import axios from 'axios';
import { GetToken } from './storageService';

// const apiUrl = "http://192.168.26.4:5555"
const apiUrl = '';
// const apiUrl = "http://localhost:64042"

export const loginRequest = async (username, password) => {
  const data = { username: username, password: password };
  try {
    let response = await axios.post(`${apiUrl}/api/login`, data);
    if (response.status == 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error.response);
    return null;
  }
  return null;
};

export const GetUsersList = async () => {
  var response = await GetRequest(`UserList`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetUsersListDeptWise = async () => {
  var response = await GetRequest(`UserListDeptWise`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetRoles = async () => {
  var response = await GetRequest(`UserRoles`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const GetDepartments = async () => {
  var response = await GetRequest(`GetDepartments`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const GetEmployeesOfDept = async () => {
  var response = await GetRequest(`GetEmployeesOfDept`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const PostUser = async (payload) => {
  let response = await PostRequest('RegisterUser', payload);
  return response;
};

export const DeleteUsers = async (payload) => {
  var response = await PostRequest(`DeleteUsers`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const GetUser = async (id) => {
  var response = await GetRequest(`GetUser/${id}`);
  if (response.status == 200) {
    // console.log("Data:",response.data);
    return response.data;
  } else return null;
};
export const GetLogedInUser = async (id) => {
  var response = await GetRequest(`GetLogedInUser`);
  if (response.status == 200) {
    // console.log("Data:",response.data);
    return response.data;
  } else return null;
};
export const EditUserDetails = async (payload) => {
  let response = await PostRequest(`updateUser`, payload);
  return response;
};
export const GetBranches = async () => {
  var response = await GetRequest(`GetBranches`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};

export const GetUserCompanies = async () => {
  var response = await GetRequest(`UserCompanies`);
  if (response != null) {
    return response.data;
  } else return null;
};

///////////////////////////////////Companies Apis/////////////////////////////////////////////////////////
export const GetCompaniesList = async () => {
  var response = await GetRequest(`Companies`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const RemaingCompanies = async () => {
  var response = await GetRequest(`RemaingCompanies`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetCompaniesByUserCompany = async (userCompany) => {
  var response = await GetRequest(`CompaniesByUserCompany/${userCompany}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const RemCompaniesByUserCompany = async (userCompany) => {
  var response = await GetRequest(`RemCompaniesByUserCompany/${userCompany}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostCompany = async (payload) => {
  let response = await PostRequest('CreateCompany', payload);
  return response;
};

export const EditCompanyDetails = async (payload) => {
  let response = await PostRequest(`editCompany`, payload);
  return response;
};
export const PostCompanyCntctInfo = async (id, payload) => {
  let response = await PostRequest(`CompanyContactInfo/${id}`, payload);
  return response;
};
export const PostCompanyBusinessInfo = async (id, payload) => {
  let response = await PostRequest(`CompanyBusinsessInfo/${id}`, payload);
  return response;
};
export const PostCompanyInfo = async (id, payload) => {
  // console.log('im in https:', id);
  let response = await PostRequest(`CompanyInfo/${id}`, payload);
  return response;
};
export const PostCompanyBusinessDetails = async (id, payload) => {
  let response = await PostRequest(`CompanyBusinessDetails/${id}`, payload);
  return response;
};
export const PostCompanyForeignWorkerInfo = async (id, payload) => {
  let response = await PostRequest(`CompanyForeignWorkerInfo/${id}`, payload);
  return response;
};
export const GetCompany = async (id) => {
  var response = await GetRequest(`GetCompany/${id}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const DeleteCompanies = async (payload) => {
  var response = await PostRequest(`DeleteCompanies`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};

///////////////////////////////////Clients Apis/////////////////////////////////////////////////////////
export const OpenGmail = async () => {
  console.log('sdsa');
  var response = await GetRequest(`OpenGmail`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const GetClientsList = async () => {
  var response = await GetRequest(`Clients`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const RemaningClients = async () => {
  var response = await GetRequest(`RemaningClients`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const RemaningClientsByCompany = async (userCompanyId) => {
  var response = await GetRequest(`RemaningClientsByCompany/${userCompanyId}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetClientsListFirstPage = async (count) => {
  var response = await GetRequest(`ClientsFirstPage/${count}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetClientsListFirstPageByCompany = async (userCompanyId) => {
  var response = await GetRequest(`ClientsFirstPageByCompany/${userCompanyId}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetInvoicesList = async (cardCode) => {
  var response = await GetRequest(`InvoicesList/${cardCode}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetClientsNearExpiry = async (days) => {
  var response = await GetRequest(`NearExpiryClients/${days}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetTotalCustomersCount = async () => {
  var response = await GetRequest(`GetTotalCustomersCount`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetIndividualCustomers = async () => {
  var response = await GetRequest(`GetIndividualCustomers`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetSAPEmployers = async () => {
  var response = await GetRequest(`GetSAPEmployers`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostClient = async (payload) => {
  let response = await PostRequest('CreateClient', payload);
  return response;
};
export const GetClient = async (id) => {
  var response = await GetRequest(`GetCLient/${id}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const EditClientDetails = async (payload) => {
  let response = await PostRequest(`editClient`, payload);
  return response;
};
export const EditClientNotes = async (payload) => {
  let response = await PostRequest(`EditClienNotes`, payload);
  return response;
};
export const EditCompanyNotes = async (payload) => {
  let response = await PostRequest(`EditCompanyNotes`, payload);
  return response;
};
export const PostClientComingToCanadaInfo = async (id, payload) => {
  let response = await PostRequest(`ComingToCanadaInfo/${id}`, payload);
  return response;
};
export const PostClientIntendedWorkInfo = async (id, payload) => {
  let response = await PostRequest(`ClientIntendedWorkInfo/${id}`, payload);
  return response;
};
export const PostClientEducationInfo = async (id, payload) => {
  let response = await PostRequest(`ClientEducationInfo/${id}`, payload);
  return response;
};
export const AddClientEducationInfo = async (id, payload) => {
  let response = await PostRequest(`AddClientEducationInfo/${id}`, payload);
  return response;
};
export const DeleteClientEducationInfo = async (id) => {
  let response = await PostRequest(`DeleteClientEducationInfo/${id}`);
  if (response != null) {
    return response;
  } else return null;
};
export const DeleteClientNotes = async (id) => {
  let response = await PostRequest(`DeleteClientNotes/${id}`);
  if (response != null) {
    return response;
  } else return null;
};
export const AddClientNotes = async (id, payload) => {
  let response = await PostRequest(`AddClientNotes/${id}`, payload);
  return response;
};
export const AddClientDependent = async (id, payload) => {
  let response = await PostRequest(`AddClientDependent/${id}`, payload);
  return response;
};
export const DeleteClientDependent = async (id) => {
  let response = await PostRequest(`DeleteClientDependent/${id}`);
  if (response != null) {
    return response;
  } else return null;
};
export const PostClientBackgroundInfo = async (id, payload) => {
  let response = await PostRequest(`ClientBackgroundInfo/${id}`, payload);
  return response;
};
export const PostClientPaymentInfo = async (id, payload) => {
  let response = await PostRequest(`ClientPaymentInfo/${id}`, payload);
  return response;
};
export const PostCreateFolder = async (payload) => {
  let response = await PostRequest(`CreateFolder`, payload);
  return response;
};
export const PostDeleteFolder = async (payload) => {
  let response = await PostRequest(`DeleteFolder`, payload);
  return response;
};
export const PostRenameFolder = async (payload) => {
  let response = await PostRequest(`RenameFolderOrFile`, payload);
  return response;
};

export const DeleteClients = async (payload) => {
  var response = await PostRequest(`DeleteClients`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};

export const GetUnalocatedClients = async () => {
  var response = await GetRequest(`UnalocatedClients`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const UnalocatedClientsFirstPage = async (count) => {
  var response = await GetRequest(`UnalocatedClientsFirstPage/${count}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const RemaningUnalocatedClients = async () => {
  var response = await GetRequest(`RemaningUnalocatedClients`);
  if (response != null) {
    return response.data;
  } else return null;
};

export const GetUnalocatedCompanies = async () => {
  var response = await GetRequest(`UnalocatedCompanies`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const RemUnalocatedCompanies = async () => {
  var response = await GetRequest(`RemUnalocatedCompanies`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const ClientsAssignment = async (id, payload) => {
  var response = await PostRequest(`ClientAssignment/${id}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const CompaniesAssignment = async (id, payload) => {
  var response = await PostRequest(`CompaniesAssignment/${id}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const GetMyOpportunitiesClients = async () => {
  var response = await GetRequest(`MyOpportunitiesClients`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const MyClientsForAssociation = async () => {
  var response = await GetRequest(`MyClientsForAssociation`);
  if (response != null) {
    return response.data;
  } else return null;
};

export const GetMyOpportunitiesCompanies = async () => {
  var response = await GetRequest(`MyOpportunitiesCompanies`);
  if (response != null) {
    return response.data;
  } else return null;
};

export const PostPerformActivity = async (payload) => {
  let response = await PostRequest(`PerformActivity`, payload);
  return response;
};

export const CreateTasks = async (id, clientCheck, payload) => {
  let response = await PostRequest(`CreateTasks/${id}/${clientCheck}`, payload);
  return response;
};
export const GetActivitiesList = async (id) => {
  var response = await GetRequest(`GetActivites/${id}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetTasksForClients = async (id) => {
  var response = await GetRequest(`GetTasksForClients/${id}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetMyTasks = async (id) => {
  var response = await GetRequest(`GetMyTasks`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetForwardedTasks = async (id) => {
  var response = await GetRequest(`ForwardedTasks`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetAssignedTasks = async (id) => {
  var response = await GetRequest(`GetAssignedTasks`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetTasksForAssignment = async (id) => {
  var response = await GetRequest(`TasksForAssignDeptWise`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostTasksAssignment = async (id, payload) => {
  var response = await PostRequest(`TasksAssignment/${id}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const MarkAsDoneReq = async (id) => {
  var response = await GetRequest(`MarkAsDone/${id}`);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const MarkAsWronglyAssignedReq = async (id) => {
  var response = await GetRequest(`MarkAsWrongly/${id}`);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const GetTask = async (id) => {
  var response = await GetRequest(`GetTask/${id}`);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const ReAssigTasks = async (id, payload) => {
  var response = await PostRequest(`ReAssigTasks/${id}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
////////////////////////Attachment//////////////////////////////////////////////////////////////
export const PostAttachment = async (id, payload, clientCheck) => {
  var response = await PostRequest(`PostAttachment/${id}/${clientCheck}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const TreePostAttachment = async (id, payload, clientCheck) => {
  var response = await PostRequest(`TreePostAttachment/${id}/${clientCheck}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const ChangeProfilePicture = async (payload) => {
  var response = await PostRequest(`ChangeProfilePicture`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const GetAttachmentsList = async (id, checkClient) => {
  var response = await GetRequest(`Attachments/${id}/${checkClient}`);
  if (response != null) {
    return response.data;
  } else return null;
};

export const GetBase64OfFiles = async (payload) => {
  var response = await PostRequest(`GetBase64OfFiles`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};

export const DownloadAttachment = async (name) => {
  const token = GetToken();
  try {
    let response = await axios.get(`${apiUrl}/api/Download/${name}`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
    });
    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};
export const DownloadTreeAttachment = async (id, checkClient, name, completePath, isTree = true) => {
  const token = GetToken();
  try {
    let params = {
      completePath: completePath,
      name: name,
      id: id,
      isTree: isTree,
    };
    let response = await axios.get(`${apiUrl}/api/DownloadTreeFile`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
      params: params,
    });
    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};
export const DeleteAttachment = async (id) => {
  var response = await GetRequest(`DeleteAttachment/${id}`);
  if (response != null) {
    return response;
  } else return null;
};

export const PostAttachmentNewMethod = async (payload) => {
  var response = await PostRequest(`uploadFile`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const GetDashboardData = async () => {
  var response = await GetRequest(`GetDashboardData`);
  if (response != null) {
    return response;
  } else return null;
};
export const DashboardData = async () => {
  var response = await GetRequest(`DashboardData`);
  if (response != null) {
    return response;
  } else return null;
};
//////////////////////////////////Alerts//////////////////////////////////////////////////////////////
export const GetMyAlerts = async (id) => {
  var response = await GetRequest(`GetMyAlerts`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const MarkAsAllRead = async (id) => {
  var response = await GetRequest(`MarkAsAllRead`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const MarkAsReadSpecific = async (id) => {
  var response = await PostRequest(`MarkAsReadSpecific/${id}`);
  if (response != null) {
    return response.data;
  } else return null;
};

///////////////////////////////////FootFalls////////////////////////////////////////////////////////////

export const GetFootfallsList = async () => {
  var response = await GetRequest(`FootfallList`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const FootfallListByUser = async () => {
  var response = await GetRequest(`FootfallListByUser`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostFootfall = async (payload) => {
  let response = await PostRequest('CreateFootfall', payload);
  return response;
};
export const GetFootfall = async (id) => {
  var response = await GetRequest(`GetFootFall/${id}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const EditFootDetails = async (payload) => {
  let response = await PostRequest(`EditFootfall`, payload);
  return response;
};
export const DeleteFootfalls = async (payload) => {
  var response = await PostRequest(`DeleteFootfalls`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};

///////////////////////////////////Vacancies////////////////////////////////////////////////////////////

export const GetVacanciesList = async () => {
  var response = await GetRequest(`VacancyList`);
  if (response != null) {
    return response.data;
  } else return null;
};

export const PostVacancy = async (payload) => {
  let response = await PostRequest('CreateVacancy', payload);
  return response;
};
export const GetVacancy = async (id) => {
  var response = await GetRequest(`GetVacancy/${id}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const EditVacancyDetails = async (payload) => {
  let response = await PostRequest(`EditVacancy`, payload);
  return response;
};
export const DeleteVacancies = async (payload) => {
  var response = await PostRequest(`DeleteVacancies`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
///////////////////////////////////Positions////////////////////////////////////////////////////////////
export const GetPositionsList = async () => {
  var response = await GetRequest(`PositionsList`);
  if (response != null) {
    return response.data;
  } else return null;
};

export const PostPosition = async (payload) => {
  let response = await PostRequest('CreatePosition', payload);
  return response;
};
export const GetPosition = async (id) => {
  var response = await GetRequest(`GetPosition/${id}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const EditPositionDetails = async (payload) => {
  let response = await PostRequest(`EditPosition`, payload);
  return response;
};
export const DeletePositions = async (payload) => {
  var response = await PostRequest(`DeletePositions`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};

///////////////////////////////////Candidates////////////////////////////////////////////////////////////
export const GetCandidatesList = async () => {
  var response = await GetRequest(`CandidatesList`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetAvailableCandidates = async (id) => {
  var response = await GetRequest(`CandidatesAvailableForScreening/${id}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostCandidate = async (payload) => {
  let response = await PostRequest('CreateCandidate', payload);
  return response;
};
export const GetCandidate = async (id) => {
  var response = await GetRequest(`GetCandidate/${id}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
export const EditCandidateDetails = async (payload) => {
  let response = await PostRequest(`EditCandidate`, payload);
  return response;
};
export const DeleteCandidates = async (payload) => {
  var response = await PostRequest(`DeleteCandidates`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const AddCandidateEducationInfo = async (id, payload) => {
  let response = await PostRequest(`AddCandidateEducationInfo/${id}`, payload);
  return response;
};
export const DeleteCandidateEducation = async (id) => {
  let response = await PostRequest(`DeleteCandidateEducations/${id}`);
  if (response != null) {
    return response;
  } else return null;
};

export const AddCandidateExperienceInfo = async (id, payload) => {
  let response = await PostRequest(`AddCandidateExperienceInfo/${id}`, payload);
  return response;
};
export const DeleteCandidateExperience = async (id) => {
  let response = await PostRequest(`DeleteCandidateExperience/${id}`);
  if (response != null) {
    return response;
  } else return null;
};
export const GetCandidateAttachmentsList = async (id) => {
  var response = await GetRequest(`CandidateAttachments/${id}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostCandidateAttachment = async (id, payload, clientCheck) => {
  var response = await PostRequest(`PostCandidateAttachment/${id}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const DeleteCandidateAttachment = async (id) => {
  var response = await GetRequest(`DeleteCandidateAttachment/${id}`);
  if (response != null) {
    return response;
  } else return null;
};
export const GetScreenedCandidatesList = async (id) => {
  var response = await GetRequest(`ScreenedCandidates/${id}`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostCandidateScreening = async (id, payload) => {
  var response = await PostRequest(`CandidateScreening/${id}`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
export const ScheduleCandidateInterviews = async (payload) => {
  let response = await PostRequest(`CreateCandidateInterview`, payload);
  return response;
};
export const ReScheduleCandidateInterview = async (id, payload) => {
  let response = await PostRequest(`ReScheduleCandidateInterview/${id}`, payload);
  return response;
};
export const DeleteCandidateInterviews = async (id) => {
  let response = await PostRequest(`DeleteCandidateInterviews/${id}`, payload);
  if (response != null) {
    return response;
  } else return null;
};
export const DeleteInterviews = async (payload) => {
  var response = await PostRequest(`DeleteInterviews`, payload);
  // if (response.status == 200) {
  if (response != null) {
    return response;
  } else return null;
};
//////////////////////////////////Interviews//////////////////////////////////////////////////////////////
export const GetInterviewsList = async () => {
  var response = await GetRequest(`InterviewsList`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetInterviewsHavetoTake = async () => {
  var response = await GetRequest(`InterviewsHavetoTake`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetAllUsers = async () => {
  var response = await GetRequest(`GetAllUsers`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const GetInterviewsYouManage = async () => {
  var response = await GetRequest(`InterviewsYouManage`);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostEvaluateInterview = async (id, payload) => {
  var response = await PostRequest(`EvaluateInterview/${id}`, payload);
  if (response != null) {
    return response.data;
  } else return null;
};
export const PostFinalEvaluateInterview = async (id, payload) => {
  var response = await PostRequest(`EvaluateFinalInterview/${id}`, payload);
  if (response != null) {
    return response.data;
  } else return null;
};

export const PostEvaluateFinalInterview = async (id, payload) => {
  var response = await PostRequest(`EvaluateFinalInterview/${id}`, payload);
  if (response != null) {
    return response.data;
  } else return null;
};
//////////////////////////////////DirectorySearch/// ///////////////////////////////////////////////////////////
export const GetDirectoryList = async (id, clientCheck) => {
  var response = await GetRequest(`GetDirectoryList/${id}/${clientCheck}`);
  if (response.status == 200) {
    return response.data;
  } else return null;
};
//////////////////////////////////Reports/// ///////////////////////////////////////////////////////////
export const GetReportsList = async () => {
  var response = await GetRequest(`ReportList`);
  if (response != null) {
    return response.data;
  } else return null;
};
// export const GetReport = async (payload) => {
//   const token = GetToken();
//   try {
//     let response = await axios.post(`GetReport`, payload, {
//       headers: {
//         Authorization: 'Bearer ' + token,
//       },
//       responseType: 'blob',
//     });
//     return response;
//   } catch (e) {
//     console.log(e);
//     return null;
//   }

// };
// export const GetReport = async (id, payload) => {
//   var response = await PostRequest(`GetReport/${id}`, payload);
//   console.log('RSPOSP', response);

//   if (response != null) {
//     return response;
//   } else return null;
// };

export const GetReport = async (id, payload) => {
  const token = GetToken();
  try {
    let response = await axios.post(`${apiUrl}/api/GetReport/${id}`, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
    });
    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};
///////////////////////////////////Old Apis/////////////////////////////////////////////////////////

const GetRequest = async (endpoint) => {
  try {
    const token = GetToken();
    let response = await axios.get(`${apiUrl}/api/${endpoint}`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
    return response;
  } catch (error) {
    console.log('Get Error: ', error?.response);
    return error?.response;
  }
};
let cancelToken;
const GetRequestWithParam = async (endpoint, id) => {
  const token = GetToken();
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.');
  }
  // console.log(cancelToken);
  //Save the cancel token for the current request
  cancelToken = axios.CancelToken.source();
  let response = await axios.get(`${apiUrl}/api/${endpoint}`, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
    params: {
      id: id,
    },
    cancelToken: cancelToken.token,
  });
  return response;
};

const PostRequest = async (endpoint, payload) => {
  const token = GetToken();
  try {
    let response = await axios.post(`${apiUrl}/api/${endpoint}`, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
    return response;
  } catch (e) {
    console.log('Post Error: ', e?.response);
    return e?.response;
  }
};
